import React, { Children } from 'react';

import { ISpecOfferDetails } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';

import Advantage from './Advantage';
import { getWidthMark } from './getWidthMark';

import * as ST from './styled';

interface IProps {
    advantages: ISpecOfferDetails,
}

const AdvantagesList = ({ advantages }: IProps): JSX.Element | null => {
    if (!advantages.items.length) {
        return null;
    }

    return (
        <ListContainer $direction={'column'} $desktop={24} $mobile={16}>
            {advantages.title && (
                <ST.BlockTitle $withIndent={false} data-test='advantages-title'>{advantages.title}</ST.BlockTitle>
            )}
            <ST.AdvantagesGrid data-test='advantages-grid'>
                {Children.toArray(getWidthMark(advantages.items).map(advantage => <Advantage {...advantage}/>))}
            </ST.AdvantagesGrid>
        </ListContainer>
    );
};

export default AdvantagesList;
